module.exports = __webpack_public_path__ + "static/img/video-error.0f868440.png";